module.exports = __webpack_public_path__ + "img/mini-logo.28af1ef4.png";